function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ManagerTemplate = require('./manager.template');
var BrowseView = require('./browse-view');
var StorefrontView = require('./storefront-view');
var SalesView = require('./sales-view');
var WithdrawalsView = require('./withdrawals');
var ModerateView = require('./moderate-view');
var Manager = /*#__PURE__*/function () {
  function Manager(app, mod) {
    var _this = this;
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var callbacks = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    _classCallCheck(this, Manager);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.activePanel = 'browse';
    this.onStoreModeChange = callbacks.onStoreModeChange;
    var onViewChange = function onViewChange(mode) {
      if (typeof _this.onStoreModeChange === 'function') {
        _this.onStoreModeChange(mode);
      }
    };
    this.browse = new BrowseView(app, mod, '');
    this.storefront = new StorefrontView(app, mod, '', {
      onSell: callbacks.onSell,
      onViewChange: onViewChange
    });
    this.sales = new SalesView(app, mod, '');
    this.withdrawals = new WithdrawalsView(app, mod, '');
    this.moderate = new ModerateView(app, mod, '');
  }
  return _createClass(Manager, [{
    key: "render",
    value: function render() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (container) {
        this.container = container;
      }
      if (!this.container) {
        return;
      }
      this.app.browser.replaceElementContentBySelector(ManagerTemplate(), this.container);
      this.browse.render("".concat(this.container, " [data-panel=\"browse\"]"));
      this.storefront.render("".concat(this.container, " [data-panel=\"my-listings\"]"));
      this.sales.render("".concat(this.container, " [data-panel=\"sales\"]"));
      this.withdrawals.render("".concat(this.container, " [data-panel=\"withdrawals\"]"));
      this.moderate.render("".concat(this.container, " [data-panel=\"moderate\"]"));
      this.show(this.activePanel);
    }
  }, {
    key: "show",
    value: function show() {
      var _this2 = this;
      var panel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'browse';
      this.activePanel = panel || 'browse';
      if (!this.container) {
        return;
      }
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }
      root.querySelectorAll('[data-panel]').forEach(function (el) {
        var match = el.getAttribute('data-panel') === _this2.activePanel;
        el.classList.toggle('is-active', match);
      });
    }

    /**
     * Open the creator storefront / admin panel for a public key.
     * @param {string} publicKey
     * @param {{ viewMode?: 'public' | 'admin' | 'admin-denied', adminSection?: 'home' | 'active' }} [opts]
     */
  }, {
    key: "showStorefront",
    value: function showStorefront() {
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$viewMode = _ref.viewMode,
        viewMode = _ref$viewMode === void 0 ? 'public' : _ref$viewMode,
        _ref$adminSection = _ref.adminSection,
        adminSection = _ref$adminSection === void 0 ? 'home' : _ref$adminSection,
        _ref$category = _ref.category,
        category = _ref$category === void 0 ? '' : _ref$category;
      this.show('my-listings');
      return this.storefront.show(publicKey, {
        viewMode: viewMode,
        adminSection: adminSection,
        category: category
      });
    }
  }, {
    key: "showSales",
    value: function showSales() {
      this.show('sales');
      return this.sales.show();
    }
  }, {
    key: "showWithdrawals",
    value: function showWithdrawals() {
      this.show('withdrawals');
      return this.withdrawals.show();
    }
  }, {
    key: "showModerate",
    value: function showModerate() {
      this.show('moderate');
      return this.moderate.show();
    }
  }, {
    key: "scrollToListings",
    value: function scrollToListings() {
      this.browse.scrollToListings();
    }
  }, {
    key: "renderListings",
    value: function renderListings() {
      this.browse.renderListings();
    }
  }, {
    key: "loadBrowsePage",
    value: function loadBrowsePage() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$category = _ref2.category,
        category = _ref2$category === void 0 ? '' : _ref2$category,
        _ref2$page = _ref2.page,
        page = _ref2$page === void 0 ? 1 : _ref2$page,
        _ref2$scroll = _ref2.scroll,
        scroll = _ref2$scroll === void 0 ? false : _ref2$scroll;
      this.show('browse');
      return this.browse.loadPage({
        category: category,
        page: page,
        scroll: scroll
      });
    }
  }, {
    key: "reloadBrowsePage",
    value: function reloadBrowsePage() {
      if (this.activePanel !== 'browse') {
        return;
      }
      return this.browse.loadPage({
        category: this.browse.category,
        page: this.browse.page,
        scroll: false
      });
    }
  }]);
}();
module.exports = Manager;